export function isBottomVisible(elementTarget) {
    return (
        elementTarget.scrollHeight - elementTarget.scrollTop <=
        elementTarget.clientHeight + 200
    );
}

export function scrollToTop() {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
}
